import _toConsumableArray from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * DevExtreme (esm/ui/text_box/ui.text_editor.mask.strategy.input_events.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import BaseMaskStrategy from "./ui.text_editor.mask.strategy.base";
var DELETE_INPUT_TYPE = "deleteContentBackward";
var InputEventsMaskStrategy = /*#__PURE__*/function (_BaseMaskStrategy) {
  _inherits(InputEventsMaskStrategy, _BaseMaskStrategy);
  function InputEventsMaskStrategy() {
    _classCallCheck(this, InputEventsMaskStrategy);
    return _possibleConstructorReturn(this, _getPrototypeOf(InputEventsMaskStrategy).apply(this, arguments));
  }
  _createClass(InputEventsMaskStrategy, [{
    key: "_getStrategyName",
    value: function _getStrategyName() {
      return "inputEvents";
    }
  }, {
    key: "getHandleEventNames",
    value: function getHandleEventNames() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(InputEventsMaskStrategy.prototype), "getHandleEventNames", this).call(this)), ["beforeInput"]);
    }
  }, {
    key: "_beforeInputHandler",
    value: function _beforeInputHandler() {
      this._prevCaret = this.editorCaret();
    }
  }, {
    key: "_inputHandler",
    value: function _inputHandler(_ref) {
      var originalEvent = _ref.originalEvent;
      if (!originalEvent) {
        return;
      }
      var inputType = originalEvent.inputType,
        data = originalEvent.data;
      var currentCaret = this.editorCaret();
      if (inputType === DELETE_INPUT_TYPE) {
        var length = this._prevCaret.end - this._prevCaret.start || 1;
        this.editor.setBackwardDirection();
        this._updateEditorMask({
          start: currentCaret.start,
          length: length,
          text: this._getEmptyString(length)
        });
      } else {
        var _this$_prevCaret, _this$_prevCaret2, _this$_prevCaret3;
        if (!currentCaret.end) {
          return;
        }
        this._autoFillHandler(originalEvent);
        this.editorCaret(currentCaret);
        var _length = (null === (_this$_prevCaret = this._prevCaret) || void 0 === _this$_prevCaret ? void 0 : _this$_prevCaret.end) - (null === (_this$_prevCaret2 = this._prevCaret) || void 0 === _this$_prevCaret2 ? void 0 : _this$_prevCaret2.start);
        var newData = data + (_length ? this._getEmptyString(_length - data.length) : "");
        this.editor.setForwardDirection();
        var hasValidChars = this._updateEditorMask({
          start: null === (_this$_prevCaret3 = this._prevCaret) || void 0 === _this$_prevCaret3 ? void 0 : _this$_prevCaret3.start,
          length: _length || newData.length,
          text: newData
        });
        if (!hasValidChars) {
          this.editorCaret(this._prevCaret);
        }
      }
    }
  }, {
    key: "_getEmptyString",
    value: function _getEmptyString(length) {
      return Array(length + 1).join(" ");
    }
  }, {
    key: "_updateEditorMask",
    value: function _updateEditorMask(args) {
      var textLength = args.text.length;
      var updatedCharsCount = this.editor._handleChain(args);
      if (this.editor.isForwardDirection()) {
        var _this$editorCaret = this.editorCaret(),
          start = _this$editorCaret.start,
          end = _this$editorCaret.end;
        var correction = updatedCharsCount - textLength;
        if (start <= updatedCharsCount && updatedCharsCount > 1) {
          this.editorCaret({
            start: start + correction,
            end: end + correction
          });
        }
        this.editor.isForwardDirection() && this.editor._adjustCaret();
      }
      this.editor._displayMask();
      return !!updatedCharsCount;
    }
  }]);
  return InputEventsMaskStrategy;
}(BaseMaskStrategy);
export default InputEventsMaskStrategy;